import {Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {HelpersService} from '../../services/helpers.service';
import {MemberModel} from '../../models/user.model';
import {MemberService} from '../../services/member.service';
import {ToastService} from '../../services/toast.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-component-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    animations: [
        trigger('fade', [
            state('in', style({opacity: 1})),
            transition(':enter', [style({opacity: 0}), animate('0.1s ease-out')]),
            transition(':leave', animate('0.1s ease-out', style({opacity: 0}))),
        ]),
    ],
})
export class HeaderComponent implements OnInit {
    @Input() public type;
    @Input() public offMenuIcons = false;
    @Output() sidebar: EventEmitter<string> = new EventEmitter<string>();
    public member: MemberModel;
    public openProfile = false;
    public openNotify = false;
    @ViewChild('menu') private menu: ElementRef;
    @ViewChild('notification') private notification: ElementRef;

    constructor(
        public helper: HelpersService,
        protected memberService: MemberService,
        public toastService: ToastService,
        protected router: Router,
    ) {
    }

    @HostListener('document:click', ['$event'])
    AfterClick(event): void {
        if (!this.menu.nativeElement.contains(event.target)) {
            this.openProfile = false;
        }

        if (!this.notification.nativeElement.contains(event.target)) {
            this.openNotify = false;
        }
    }

    ngOnInit(): void {
        this.memberService.getCurrentMember().then(data => {
            this.member = data;
        });
    }


    switchNotify(): void {
        if (this.openNotify) {
            this.toastService.newNotification = 0;
            this.toastService.notification.filter(x => x.isNew).map(notif => {
                notif.isNew = false;
            });
        }

        this.openNotify = !this.openNotify;
    }

    /**
     * Адаптивное меню
     */
    sidebarEmit(type): void {
        this.sidebar.emit(type);
    }

    /**
     * Выход пользователя с модалкой
     */
    logout(): void {
        this.memberService.logout();
    }
}
